import { useCallback, useEffect, useRef, useState } from 'react';
import type { ProductVariant } from '../../types/pz';
import {
  fetchProductSelectionCatalog,
  type ProductSelectionPurchasePriceScope,
} from './productSelectionApi';

export function useProductSelectionCatalog(
  enabled = true,
  purchasePriceScope?: ProductSelectionPurchasePriceScope,
) {
  const [variants, setVariants] = useState<ProductVariant[]>([]);
  const [loading, setLoading] = useState(false);
  const loadSequence = useRef(0);

  const load = useCallback(async (force = false) => {
    const sequence = ++loadSequence.current;
    setLoading(true);
    try {
      const data = await fetchProductSelectionCatalog(force, purchasePriceScope);
      if (sequence === loadSequence.current) setVariants(data);
      return data;
    } finally {
      if (sequence === loadSequence.current) setLoading(false);
    }
  }, [purchasePriceScope]);

  useEffect(() => {
    if (!enabled) return;
    load().catch((error) => console.error('Error fetching product selection catalog:', error));
  }, [enabled, load]);

  return { variants, loading, reload: () => load(true) };
}
